import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { SiteInfoProvider } from './context/SiteInfoContext';
import { VehiclesProvider } from './context/VehiclesContext';
import './App.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <SiteInfoProvider>
        <VehiclesProvider>
          <App />
        </VehiclesProvider>
      </SiteInfoProvider>
    </BrowserRouter>
  </React.StrictMode>
);
